import React, { useEffect, useState } from 'react';
import './index.css';
// eslint-disable-next-line import/no-cycle
import { Tag } from '../index';

const { dateFormat, priceFormat } = require('@cashew/utils');

const ns = 'history-item';

export default ({
  data: {
    chargeDate,
    amount,
    currency,
    cardType,
    status,
    cardNumber,
    installments,
  },
}: any) => {
  let paymentType =
    cardType?.length > 6 ? `${cardType?.slice(0, 6)}...` : cardType;

  if (cardNumber?.length) {
    paymentType = `${paymentType} ${cardNumber
      ?.toString()
      .substring(cardNumber?.length - 4)}`;
  }
  const [tagStatus, setTagStatus] = useState({
    type: 'CANCELLED',
    text: 'Cancelled',
  });
  useEffect(() => {
    switch (status) {
      case 'PAID':
        setTagStatus({ type: 'PAID', text: 'Paid' });
        break;
      case 'REFUNDED':
        setTagStatus({ type: '', text: 'Refunded' });
        break;
      default:
        setTagStatus({ type: 'CANCELLED', text: 'Cancelled' });
    }
  }, [status]);

  return (
    <div className={ns}>
      <div>{installments}</div>
      <div>{dateFormat({ date: chargeDate })}</div>
      <div>
        {status !== 'CANCELLED'
          ? priceFormat({
              currency,
              amount,
            })
          : ''}
      </div>
      <div>
        <Tag status={tagStatus.type}>{tagStatus.text}</Tag>
      </div>
      <div>{paymentType}</div>
    </div>
  );
};
